// extracted by mini-css-extract-plugin
module.exports = {"root":"secondary_root__Ojmt1"};